import { romeApi, utils } from "framework";

const state = {
  employerId: null,
  brokerId: null,
  firstName: null,
  lastName: null,
  fullName: null,
  agency: null,
  phone: null,
  phoneExtension: null,
  fax: null,
  email: null,
  address1: null,
  address2: null,
  city: null,
  state: null,
  zip: null,
  userId: null,
  hipaaOptions: [],
  brokerResponsibilities: [],
  pendingActionItem: null,
  partner:null,
  partnerList:[],
};

const getters = {};

const actions = {
  async getEmployerBroker({ commit, rootState, state, dispatch }, data) {
    let id = rootState.employer.employerId;
    if (!id || (data && data.employerId && data.employerId == state.employerId)) return;
    let broker = await romeApi.get(`/employer/${id}/broker`);

    if (broker) {
        commit('setEmployerBroker', broker);
    } else {
        commit('clearEmployerBroker');
        dispatch("getHipaaOptions");
        dispatch("getBrokerResponsibilities");
    }

    let pendingActionItemId = await romeApi.get(`/employer/${id}/broker/actionItem`);
    if (pendingActionItemId) {
      let pendingActionItem = await romeApi.get(`/actionitem/v-2/${pendingActionItemId.actionItemId}`);
      commit('setPendingActionItems', pendingActionItem);
    } else {
      commit('clearPendingActionItems');
    }
  },
  async updateEmployerBroker({ commit, dispatch, rootState, state }, brokerData) {
    let id = rootState.employer.employerId;
    if (!id) return;

    await romeApi.post(`/employer/${id}/broker/assign/${brokerData.brokerId}`);

    dispatch('getEmployerBroker');
  },
  async updateEmployerPartner({ commit, dispatch, rootState, state }, partnerData) {
    let id = rootState.employer.employerId;
    if (!id) return;

    await romeApi.post(`/partner/${partnerData.partnerId}/EmployerPartner`, partnerData);

    dispatch('loadEmployerPartner');
  },
  async removeEmployerPartner({ commit, dispatch, rootState, state}, partnerData) {
    const id = rootState.employer.employerId;
    if (!id) return;

    await romeApi.delete(`/partner/${partnerData.partnerId}/EmployerPartner/${id}`);

    commit('setEmployerPartner', null);
  },
  async removeEmployerBroker({ commit, dispatch, rootState, state}, partnerData) {
    const id = rootState.employer.employerId;
    const brokerId = state.brokerId;
    if (!id || !brokerId)
    { console.log("no both ids"); return;}

    await romeApi.post(`employer/${id}/broker/delete/${brokerId}`)

    commit('setEmployerBroker', null);
  },
  async submitBrokerChange({ commit, dispatch, rootState, state }, broker) {
    let id = rootState.employer.employerId;
    if (!id) return;

    let postData = state;
    _.assign(postData, broker);

    await romeApi.post(`/employer/${id}/broker/brokerofrecord`, postData);
    dispatch('getEmployerBroker');
  },
  async getHipaaOptions({commit}) {
    let options = await romeApi.get('broker/options');
    commit('setHipaaOptions', options);
  },
  async getBrokerResponsibilities({commit}) {
    let responsibilities = await romeApi.get('broker/responsibilities');
    commit('setBrokerResponsibilities', responsibilities);
  },
  async loadEmployerPartner({ commit, rootState, state },data)
  {
    let id = rootState.employer.employerId;
    if (!id || (data && data.employerId && data.employerId == state.employerId)) return;

    let partnerList = await romeApi.get('partner');
    commit('setPartnerList', partnerList);

    let partner = await romeApi.get(`/partner/${id}/GetPartner`);
    commit('setEmployerPartner', partner);
  }
};

const mutations = {
  clearEmployerBroker(state) {
      utils.resetStoreStateProperties(state);
  },
  setEmployerBroker(state, data) {
      utils.copyCommonProperties(data, state);
  },
  setEmployerPartner(state, data) {
    state.partner = data ? { ...data } : null;
  },
  setHipaaOptions(state, options) {
      state.hipaaOptions = options;
  },
  setBrokerResponsibilities(state, responsibilities) {
      state.brokerResponsibilities = responsibilities;
  },
  setPartnerList(state, data)
  {
    state.partnerList = [ ...data ];
  },
  setPendingActionItems(state, data) {
      state.pendingActionItem = data;
  },
  clearPendingActionItems(state) {
    state.pendingActionItem = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/employer/x-employer-broker.js